import store from '@/store'
import { validate } from 'vee-validate'
import { getActiveStepFlow, AUTH_REGISTER_V2_CHILDREN as STEP } from '@/router/routes/utils'

export const stepData = {
  [STEP.SET_EMAIL]: {
    fields: {
      email: 'required|email',
      password: 'required|min:8',
    },
  },
  [STEP.SET_OTP]: {
    // TODO: check if validation needed
  },
  [STEP.COMPLETE_INFO]: {
    fields: {
      firstName: 'required|min:3|max:100',
      lastName: 'required|min:3|max:100',
      country: 'required',
      phone: 'required',
    },
  },
  [STEP.COMPANY_INFO]: {
    fields: {
      companyName: 'required|min:3|max:100',
    },
  },
  [STEP.CHOOSE_USER_TYPE]: {
    fields: {
      userType: 'required',
    },
  },
  [STEP.SET_LAUNCH_DATE]: {
    fields: {
      selectedLaunchDate: 'required',
    },
  },
  [STEP.SET_CREDENTIALS]: {
    fields: {
      login: 'required|min:4',
      password: 'required|min:8',
    },
  },
  [STEP.CONFIRM]: {
    // No validation needed
  },
}

export const verifyAllSteps = async () => {
  const steps = getActiveStepFlow()

  // STEP 1: Flatten to list of validations
  const validations = steps.flatMap(({ key }) => {
    const fields = stepData[key]?.fields
    if (!fields) return []

    return Object.entries(fields).map(([fieldName, rules]) => ({
      key,
      fieldName,
      rules,
      value: store.state.register.formData[fieldName],
    }))
  })

  // STEP 2: Run validations in parallel
  const results = await Promise.all(
    validations.map(({
      key, fieldName, rules, value,
    }) => validate(value, rules, { name: fieldName }).then(result => ({
        valid: result.valid,
        key,
      }))),
  )

  // STEP 3: Find first failing step
  const failed = results.find(r => !r.valid)
  return failed ? failed.key : null
}
